export default "__VITE_ASSET__FVQA$Y4B__"